export enum APPLICABLE_STATE_NAME {
  APPLICABLE = 'APPLICABLE',
  NEXT_APPLICABLE = 'NEXT_APPLICABLE',
}

export enum STARRED_ACTION_TYPE {
  NONE = "none",
  ADD = "add",
  DELETE = "delete",
}

export interface IParentDocument {
  id: string;
  letter: string;
  source: string;
  offline: boolean;
  category: ICategory;
  activityCode: string;
  serialNumber: number;
  acknowlegment: boolean;
}

export interface IPdfFile {
  id: string;
  name: string;
  size: number;
  hash: number;
  isFav: boolean;
  pdfBuffer?: ArrayBuffer;
}

export interface IPdfFileMeta {
  id: string;
  name: string;
  size: number;
  hash: number;
  isFav: boolean;
  readDate?: string;
  isBufferSavedInDB?: boolean;
  thumbnailBufferSize?: number;
  thumbnailBuffer?: ArrayBuffer;
}

interface IUserDocumentStatus {
  lastRead: string;
  ackDate: string;
  isFav: boolean;
  isAck: boolean;
}

export interface IDocumentVersion {
  id: string;
  name: string;
  title: string;
  file: IPdfFile;
  version: number;
  endDate?: string;
  startDate: string;
  maxDuration?: number;
  creationDate: string;
  uds: IUserDocumentStatus;
  lastMetaModification: string;
  lastFileModification: string;
  parentDocument: IParentDocument;
  applicableStateName: APPLICABLE_STATE_NAME;
}

interface ICategory {
  id: string;
  name: string;
}

export interface ISynchronizationItem {
  id: string;
  name: string;
  categoryOrder: number;
  applicables: IDocumentVersion[];
  nextApplicables: IDocumentVersion[];
  notApplicables: IDocumentVersion[];
  noMoreTargeted: IDocumentVersion[];
  category: ICategory;
  lastUpdate: Date;
  starredDocumentsCount: {
    applicables: number;
    nextApplicables: number;
  };
  unaknowledgedCount: number;
}

export interface ISynchronizationItemMeta {
  id: string;
  name: string;
  categoryOrder:number;
  
  categoriesDocumentVersionsCount: number;
  categoriesApplicableDocumentsCount: number;
  categoriesNextApplicableDocumentsCount: number;
  categoriesIsAckRequiredApplicableDocumentsCount: number;
  categoriesIsAckRequiredNextApplicableDocumentsCount: number;
  
  starredDocumentVersionsCount: number;
  starredApplicableDocumentsCount: number;
  starredNextApplicableDocumentsCount: number;
  starredIsAckRequiredApplicableDocumentsCount: number;
  starredIsAckRequiredNextApplicableDocumentsCount: number;

  acknowledgementDocumentVersionsCount: number;
  acknowledgementApplicableDocumentsCount: number;
  acknowledgementNextApplicableDocumentsCount: number;
  acknowledgementIsAckRequiredApplicableDocumentsCount: number;
  acknowledgementIsAckRequiredNextApplicableDocumentsCount: number;
  
  offlineDocumentsVersionCount: number;
}

export interface ISetting {
  key: string;
  value: string | boolean;
}

export interface IHomePageInfo {
  mostRead: IDocumentVersion[];
  lastRead: IDocumentVersion[];
  lastAddedApplicables: IDocumentVersion[];
  lastAddedNextApplicables: IDocumentVersion[];
}